import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootState } from '../../app/store'
import { useSelector } from 'react-redux'
import { addNewTransaction, resetTansactionSavedDetails, updateTransactionModalStatus } from './transactionsSlice'
import Tabs, { ITab } from '../../components/Tabs'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import TransactionsApp, { EmptyTransactionModel, ITransactionModal } from "./TransactionsApp"
import ItemsApp, { IItemModel } from '../items/ItemsApp'
import WarehousesApp, { IWarehouseModel } from '../warehouses/WarehousesApp'
import SectionsApp, { ISectionModel } from '../sections/SectionsApp'
import LocationsApp, { ILocationModel } from '../locations/LocationsApp'
import UsersApp from '../user/UsersApp'
import DynamicModelSelect from '../../components/Fields/DynamicModelSelect'
import { Button, Skeleton, TextField } from '@mui/material'
import ItemInventory from '../items/ItemInventory'
import { handleRequestError } from '../../services/api'
import BasicModalWindow from '../../components/BasicModalWIndow'
import QuantitySlider from './QuantitySlider'
import SelectTransactionActions from './SelectTransactionActions'
import SelectTransactionType from './SelectTransactionType'
import RequestDesignation from '../items_requests/RequestDesignation'
import Grid from '@mui/material/Grid2';
import ProjectsApp from '../projects/ProjectsApp'
import DateAndTimeField from '../../components/Fields/DateAndTimeField'
import GenerateIcon from '../../components/GenerateIcon'
import { IUserModel } from '../../services/user'
import TranscationDetails from './TranscationDetails'
import { IAxiosDefaultDataObject } from '../../config'
import { updateInventoryItemListRefresh, updateItem, updateSingleItemPageForceRefresh } from '../items/itemsSlice'
import { LoadingButton } from '@mui/lab'
import { useLocation, useMatch } from 'react-router-dom'
import { useReturnCurrentUser } from '../user/userSlice'
import AlertElement from '../../components/AlertElement'

interface ICreateTransactionProps {
    itemId?: number,
}

export default function CreateTransaction(props: ICreateTransactionProps) {

    const dispatch = useDispatch()
    const { itemId } = props

    const matchItemView = useMatch("/items/view/:id")
    const matchPanelItemView = useMatch("/panel/items/view/:id")
    
    const isItemViewPage = !!(matchItemView || matchPanelItemView)

    const currentUser = useReturnCurrentUser()

    const [activateTab, setActiveTab] = useState<string>("item")
    const [availbaleTabs, setAvailbaleTabs] = useState<string[]>([
        "item"
    ])

    const [loading, setLoading] = useState<boolean>(false) // used for handleSubmit only

    const { triggerModalOpen, savedDetails, modalOpenStatus } = useSelector((state: RootState) => state.transactions)
    const [showQuantityModal, setShowQuantityModal] = useState<boolean>(false)

    const [selectedItem, setSelectedItem] = useState<number | null>(null)
    const [itemDetails, setItemDetails] = useState<IItemModel | null>(null)

    const [transcationType, setTranscationType] = useState<string>("")
    const [transcationAction, setTranscationAction] = useState<string>("")

    const [isInventorySelected, setIsInventorySelected] = useState<boolean>(false)

    const [projectId, setProjectId] = useState<number | null>(null)
    const [fromWarehouse, setFromWarehouse] = useState<number | null>(null)
    const [fromSection, setFromSection] = useState<number | null>(null)
    const [fromLocation, setFromLocation] = useState<number | null>(null)
    const [fromUser, setFromUser] = useState<number | null>(null)

    const [toWarehouse, setToWarehouse] = useState<number | null>(null)
    const [toSection, setToSection] = useState<number | null>(null)
    const [toLocation, setToLocation] = useState<number | null>(null)
    const [toUser, setToUser] = useState<number | null>(null)

    const [quantity, setQuantity] = useState<number>(0)
    const [maxQuantity, setMaxQuantity] = useState<number>(0)

    const [timestamp, setTimestamp] = useState<Date | null>(new Date())
    const [note, setNote] = useState<string>("")

    const [fromWarehouseTitle, setFromWarehouseTitle] = useState<string>("") 
    const [fromSectionTitle, setFromSectionTitle] = useState<string>("") 
    const [fromLocationTitle, setFromLocationTitle] = useState<string>("")
    const [fromUserTitle, setFromUserTitle] = useState<string>("") 

    const [toWarehouseDetails, setToWarehouseDetails] = useState<IWarehouseModel | null>(null)
    const [toSectionDetails, setToSectionDetails] = useState<ISectionModel | null>(null)
    const [toLocationDetails, setToLocationDetails] = useState<ILocationModel | null>(null)
    const [toUserDetails, setToUserDetails] = useState<IUserModel | null>(null)

    /**
     * Apps
     */
    const transcationsApp = new TransactionsApp()
    const projectsApp = new ProjectsApp()
    const itemsApp = new ItemsApp()
    const warehousesApp = new WarehousesApp()
    const sectionsApp = new SectionsApp()
    const locationsApp = new LocationsApp()
    const usersApp = new UsersApp()

    /**
     * Handle close modal
     */
    const handleCloseModal = () => dispatch(updateTransactionModalStatus(false))

    /**
     * Update availbale tabs
     */
    const addAvailableStep = (step: string) => setAvailbaleTabs(prev =>
        prev.includes(step) ? prev : [...prev, step]
    )

    const removeAvailableStep = (step: string) => setAvailbaleTabs(prev =>
        prev.filter(s => s !== step)
    )

    /**
     * Trigger inventory list refresh
     */
    const triggerInventoryListRefresh = () => dispatch(updateInventoryItemListRefresh(true))

    /**
     * Reset saved details
     */
    const resetSavedDetails = () => dispatch(resetTansactionSavedDetails({}))

    /**
     * Reset 
     */
    const handleReset = () => {
        setSelectedItem(null)
        setTranscationType("")
        setTranscationAction("")
        setToWarehouse(null)
        setToSection(null)
        setToLocation(null)
        setToUser(null)
        setTimestamp(new Date())
        setNote("")

        setFromWarehouse(null)
        setFromSection(null)
        setFromLocation(null)
        setFromUser(null)
        resetSavedDetails()
        setQuantity(0)
        setMaxQuantity(0)

        setAvailbaleTabs([
            "item"
        ])
        setActiveTab("item")

        setItemDetails(null)
        setProjectId(null)

        setFromWarehouseTitle("")
        setFromSectionTitle("")
        setFromLocationTitle("")
        setFromUserTitle("")

        setToWarehouseDetails(null)
        setToSectionDetails(null)
        setToLocationDetails(null)
        setToUserDetails(null)
        
        handleCloseModal()
    }

    /**
     * Handle close
     */
    const handleClose = () => {
        handleReset()
    }

    /**
     * Load Item
     */
    const loadItem = () => {
        if (!selectedItem){
            return;
        }

        itemsApp.singleInstanceDetails(selectedItem)
            .then(response => setItemDetails(response.data))
            .catch(error => handleRequestError(error, dispatch))
    }

    /**
     * Load to warehouse
     */
    const loadToWarehouse = () => {
        if (!toWarehouse){
            return;
        }

        if (toWarehouseDetails){
            if (toWarehouseDetails.id === toWarehouse){
                return;
            }
        }

        warehousesApp.singleInstanceDetails(toWarehouse)
            .then(response => setToWarehouseDetails(response.data))
    }

    /**
     * Load section
     */
    const loadToSection = () => {
        if (!toSection){
            return;
        }

        if (toSectionDetails){
            if (toSectionDetails.id === toSection){
                return;
            }
        }

        sectionsApp.singleInstanceDetails(toSection)
            .then(response => setToSectionDetails(response.data))
    }

    /**
     * Load location
     */
    const loadToLocation = () => {
        if (!toLocation){
            return;
        }

        if (toLocationDetails){
            if (toLocationDetails.id === toLocation){
                return;
            }
        }

        locationsApp.singleInstanceDetails(toLocation)
            .then(response => setToLocationDetails(response.data))
    }

    /**
     * Load user
     */
    const loadToUser = () => {
        if (!toUser){
            return;
        }

        if (toUserDetails){
            if (toUserDetails.id === toUser){
                return;
            }
        }

        usersApp.singleInstanceDetails(toUser)
            .then(response => setToUserDetails(response.data))
    }

    /**
     * Handle close quantity modal
     */
    const handleCloseQuantityModal = () => {
        setShowQuantityModal(false)
        setMaxQuantity(0)
        setQuantity(0)

        setFromWarehouse(null)
        setFromLocation(null)
        setFromSection(null)
        setFromUser(null)
        setIsInventorySelected(false)

        setFromUserTitle("")
        setFromWarehouseTitle("")
        setFromSectionTitle("")
        setFromLocationTitle("")
    }

    /**
     * Handle quantity selected
     */
    const handleQuantitySelected = () => {
        setIsInventorySelected(true)
        setShowQuantityModal(false)
    }

    /**
     * Selected item
     */
    useEffect(() => {
        if (itemId){
            setSelectedItem(itemId)
            setActiveTab("inventory")
        }
    }, [itemId])

    useEffect(() => {
        if (selectedItem){
            loadItem()
        }
    }, [selectedItem])

    /**
     * Current user
     */
    useEffect(() => {

        if (!currentUser.is_superuser){
            
            if (transcationType === "user" || transcationType === "with-user"){
                setToUser(currentUser.id)
            }else{
                if (activateTab === "details"){
                    setToUser(currentUser.id)
                }
            }
        }

    }, [currentUser, transcationType, activateTab])

    /**
     * Update availbale step
     */
    useEffect(() => {

        if (selectedItem){
            addAvailableStep("inventory")
            setActiveTab("inventory")
        }else{
            removeAvailableStep("inventory")
        }

        if (isInventorySelected){
            addAvailableStep("action")
            setActiveTab("action")
        }else{
            removeAvailableStep("action")
        }

        if (transcationAction){
            addAvailableStep("destination_type")
            setActiveTab("destination_type")
        }else{
            removeAvailableStep("destination_type")
        }

        if (transcationType){
            setActiveTab("destination")
            addAvailableStep("destination")
        }else{
            removeAvailableStep("destination")
        }

    }, [selectedItem, isInventorySelected, transcationAction, transcationType])

    /**
     * Show details
     */
    useEffect(() => {

        let showDetails: boolean = false

        if (toWarehouse && toSection){
            showDetails = true
            loadToWarehouse()
            loadToSection()
        }

        if (toLocation){
            showDetails = true
            loadToLocation()
        }

        if (toUser){
            showDetails = true
            loadToUser()
        }

        if (showDetails){
            setActiveTab("details")
            addAvailableStep("details")
        }else{
            removeAvailableStep("details")
        }

    }, [toWarehouse, toSection, toLocation, toUser])

    /**
     * Go to final
     */
    const goToFinal = () => {
        setActiveTab("final")
        addAvailableStep("final")
    }

    /**
     * No tab
     */
    const renderNoTab = () => {
        return <></>
    }

    /**
     * Item Tab
     */
    const renderItemTab = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select Item"
            >
                <DynamicModelSelect 
                    id="item_id"
                    type="DynamicModelSelect"
                    xs={12}
                    handleOnChange={(id: string, value: any) => setSelectedItem(value)}
                    data={{ name: "designation_location", value: selectedItem }}
                    fullWidth
                    appClass={itemsApp}
                    selectLabel="Select Item"
                    label="Item"
                    gridColumns={itemsApp.gridDataColumns}
                />
            </SectionBoxContainer>
        )
    }

    /**
     * Select Inventory
     */
    const renderSelectInventory = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select Origin"
            >

                {!itemDetails ? (
                    <>
                        <Skeleton variant="rectangular" width={"100%"} height={60} style={{ marginBottom: 10 }} />
                        <Skeleton variant="rectangular" width={"100%"} height={60} style={{ marginBottom: 10 }} />
                        <Skeleton variant="rectangular" width={"100%"} height={60} style={{ marginBottom: 10 }} />
                    </>
                ) : (
                    <ItemInventory 
                        itemUniqueId={itemDetails.unique_id} 
                        displayOnlyRecords 
                        customButtons={(inventory) => {

                            let disabled: boolean = false

                            if (inventory.quantity === 0){
                                disabled = true
                            }

                            const onClick = () => {
                                setMaxQuantity(inventory.quantity)
                                setFromWarehouse(inventory.warehouse_id)
                                setFromSection(inventory.section_id)
                                setFromLocation(inventory.location_id)
                                setFromUser(inventory.user_id)

                                setFromUserTitle(inventory.user)
                                setFromWarehouseTitle(inventory.warehouse)
                                setFromSectionTitle(inventory.section)
                                setFromLocationTitle(inventory.location)

                                if (inventory.quantity === 1){
                                    setQuantity(inventory.quantity)
                                    setIsInventorySelected(true)
                                }else{
                                    setShowQuantityModal(true)
                                }
                            }

                            return(
                                <div>
                                    <Button disabled={disabled} className="general-button" color="success" variant="text" onClick={() => onClick()}>Select</Button>
                                </div>
                            )
                        }}
                    />
                )}
            </SectionBoxContainer>
        )
    }

    /**
     * Select transcation type
     */
    const renderSelectTranscationType = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select Transaction Type"
            >
                <SelectTransactionActions selectedType={transcationAction} handleSelectedType={(type) => setTranscationAction(type)} />
            </SectionBoxContainer>
        )
    }

    /**
     * Render Destination Type
     */
    const renderDestinationType = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select Destination Type"
            >
                <SelectTransactionType selectedType={transcationType} selectedAction={transcationAction} handleSelectedType={(type) => setTranscationType(type)} />
            </SectionBoxContainer>
        )
    }

    /**
     * Select Destination
     */
    const renderSelectDestination = () => {

        const convertType = (type: string) => {
            let destinationType = ""

            switch(type){

                case "to-warehouse":
                    destinationType = "warehouse"
                    break

                case "to-section":
                    destinationType = "warehouse"
                    break

                case "to-location":
                    destinationType = "location"
                    break

                case "with-user":
                    destinationType = "user"
                    break

            }

            return destinationType
        }

        return(
            <SectionBoxContainer
                showTitle
                title="Select Destination"
            >
                <RequestDesignation 
                    actionType={transcationAction}
                    designationType={convertType(transcationType)}

                    warehouseId={toWarehouse}
                    sectionId={toSection}
                    locationId={toLocation}
                    userId={toUser}

                    updateWarehouseId={(id) => setToWarehouse(id)}
                    updateSectionId={(id) => setToSection(id)}
                    updateLocationId={(id) => setToLocation(id)}
                    updateUserId={(id) => setToUser(id)}

                    disableSelectUserId={currentUser.is_superuser ? false : true}
                />
            </SectionBoxContainer>
        )
    }

    /**
     * Render Details
     */
    const renderDetails = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Details"
            >
                <Grid container spacing={2}>

                    {transcationType !== "with-user" && (
                        <Grid size={{ xs: 12 }}>

                            <DynamicModelSelect 
                                id="user_id"
                                type="DynamicModelSelect"
                                xs={12}
                                handleOnChange={(id: string, value: any) => setToUser(value)}
                                data={{ name: "user_id", value: toUser }}
                                fullWidth
                                appClass={usersApp}
                                selectLabel="Select User"
                                label="User"
                                gridColumns={usersApp.gridDataColumns}
                                disabled={currentUser.is_superuser ? false : true}
                            />

                        </Grid>
                    )}

                    <Grid size={{ xs: 6 }}>

                        <DynamicModelSelect 
                            id="project_id"
                            type="DynamicModelSelect"
                            xs={12}
                            handleOnChange={(id: string, value: any) => setProjectId(value)}
                            data={{ name: "project_id", value: projectId }}
                            fullWidth
                            appClass={projectsApp}
                            selectLabel="Select Project"
                            label="Porject"
                            gridColumns={projectsApp.gridDataColumns}
                        />

                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <DateAndTimeField 
                            id="timestamp"
                            label="Timestamp"
                            type="DateAndTime"
                            xs={12}
                            handleOnChange={(id: string, value: any) => setTimestamp(value)}
                            data={{ name: "timestamp", value: timestamp }}
                            fullWidth
                        />
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <TextField variant="outlined" value={note} multiline minRows={5} maxRows={10} onChange={(e) => setNote(e.target.value)} fullWidth label="Note" />
                    </Grid>

                </Grid>

                <div className="action-buttons-of-section-box-admin-panel items-requests">
                    <div className="content-of-action-buttons-of-section-box-admin-panel">
                        <Button disabled={toUser ? false : true} className="general-button admin-style light-button" color="success" variant="contained" startIcon={<GenerateIcon icon="next" />} onClick={() => goToFinal()}>Next</Button>
                    </div>
                </div>

            </SectionBoxContainer>
        )
    }

    /**
     * Handle Submit
     */
    const handleSubmit = () => {


        let data: IAxiosDefaultDataObject = {
            item_id: selectedItem,
            user_id: toUser,
            action: transcationAction,
            type: transcationType,
            timestamp: timestamp,
            warehouse_id: toWarehouse,
            section_id: toSection,
            location_id: toLocation,
            // project_id: projectId,
            quantity: quantity,
            from_warehouse: fromWarehouse ? fromWarehouse : null,
            from_section: fromSection ? fromSection : null,
            from_location: fromLocation ? fromLocation : null,
            from_user: fromUser ? fromUser : null,
            note: note
        }

        if (projectId){
            data.project_id = projectId
        }

        // if (!currentLoggedInUser.is_superuser){
        //     data.user_id = currentLoggedInUser.id
        // }

        setLoading(true)

        transcationsApp.createNewInstance(data)
            .then(response => {

                if (isItemViewPage){
                    window.location.reload()
                }

                setLoading(false)
                dispatch(addNewTransaction(response.data))

                triggerInventoryListRefresh()

                handleClose()

                /**
                 * Update item
                 */
                    if (selectedItem){
                        itemsApp.singleInstanceDetails(selectedItem)
                            .then(response => {
                                dispatch(updateItem(response.data))
                            })
                            .catch(error => handleRequestError(error, dispatch))
                    }
                

            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })

    }

    /**
     * Final step
     */
    const renderFinalStep = () => {
        
        const returnNullOrVal = (val: number | null | undefined) => {
            if (val){
                return val
            }

            return 0
        }

        const transcationObject: ITransactionModal = {
            ...EmptyTransactionModel,
            item_id: returnNullOrVal(selectedItem),
            user_id: returnNullOrVal(toUser),
            action: transcationAction,
            type: transcationType,
            timestamp: timestamp ? new Date(timestamp).toString() : "",
            warehouse_id: returnNullOrVal(toWarehouse),
            section_id: returnNullOrVal(toSection),
            location_id: returnNullOrVal(toLocation),
            original_warehouse_title: fromWarehouseTitle,
            original_section_title: fromSectionTitle,
            original_location_title: fromLocationTitle,
            original_user_title: fromUserTitle,
            note: note,
            project_id: returnNullOrVal(projectId),
            original_warehouse_id: returnNullOrVal(fromWarehouse),
            original_section_id: returnNullOrVal(fromSection),
            original_location_id: returnNullOrVal(fromLocation),
            original_user_id: returnNullOrVal(fromUser),
            quantity: quantity,
            warehouse_title: toWarehouseDetails ? toWarehouseDetails.title : "",
            section_title: toSectionDetails ? toSectionDetails.title : "",
            location_title: toLocationDetails ? toLocationDetails.title : "",
            user_full_name: toUserDetails ? toUserDetails.full_name : "",
        }

        return(
            <SectionBoxContainer
                showTitle
                title="Create transcation"
            >
                <TranscationDetails {...transcationObject} />

                <div className="action-buttons-of-section-box-admin-panel items-requests">
                    <div className="content-of-action-buttons-of-section-box-admin-panel">
                        <LoadingButton loading={loading} className="general-button admin-style light-button" color="success" variant="contained" startIcon={<GenerateIcon icon="done" />} onClick={() => handleSubmit()}>Create Transaction</LoadingButton>
                    </div>
                </div>
            </SectionBoxContainer>
        )
    }

    /**
     * Tabs
     */
    const tabs: ITab[] = [
        {
            name: "item",
            title: "Item",
            icon: "list",
            component: renderItemTab
        },
        {
            name: "inventory",
            title: "Select Origin",
            icon: "inventory",
            component: renderSelectInventory
        },
        {
            name: "action",
            title: "Transaction Type",
            icon: "transfer",
            component: renderSelectTranscationType
        },
        {
            name: "destination_type",
            title: "Destination Type",
            icon: "move",
            component: renderDestinationType
        },
        {
            name: "destination",
            title: "Destination",
            icon: "move",
            component: renderSelectDestination
        },
        {
            name: "details",
            title: "Details",
            icon: "list",
            component: renderDetails
        },
        {
            name: "final",
            title: "Confirm",
            icon: "success",
            component: renderFinalStep
        }
    ]

    if (itemDetails){
        if (itemDetails.parent_item){
            return <AlertElement type="error" message="You can't create a trasncation for this item because it's a part of a container." />
        }
    }

    return(
        <div className="create-new-transaction-container">

            <BasicModalWindow
                shown={showQuantityModal}
                size="sm"
                handleClose={handleCloseQuantityModal}
                showHeader
                title="Select Quantity"
                actionButtons={[
                    {
                        label: "Done",
                        color: "success",
                        onClick: handleQuantitySelected,
                        disabled: quantity > 0 ? false : true
                    },
                    {
                        label: "Cancel",
                        color: "error",
                        onClick: handleCloseQuantityModal
                    }
                ]}
                actionButtonsBottom
            >
                <QuantitySlider itemMaxAvailableQnt={maxQuantity} quantity={quantity} updateQuantity={(qnt) => setQuantity(qnt)} />
            </BasicModalWindow>

            <Tabs 
                activeTab={activateTab}
                availableTabs={availbaleTabs}
                updateActivateTab={(tab) => setActiveTab(tab)}
                tabs={tabs}
            />
        </div>
    )
}